<div class="painel">
	<app-banner-internal title="Painel de medição" subtitle="Visitas, cliques e formulários do site"></app-banner-internal>

	<div class="painel-container">
		<div class="painel-status">
			<p *ngIf="report">
				Dados do Google Tag Manager de {{ report.fetchedAt | date: "dd/MM/yyyy 'às' HH:mm" }}
			</p>
			<p *ngIf="!report && loading">Carregando os dados do Google Tag Manager...</p>
			<div class="painel-status-actions">
				<button *ngIf="report" type="button" class="btn-outline" [disabled]="loading" (click)="loadGtm()">
					{{ loading ? 'Atualizando...' : 'Atualizar dados' }}
				</button>
				<button type="button" class="btn-link" (click)="logout()">Sair</button>
			</div>
		</div>

		<div class="bloco bloco-error" *ngIf="error">
			<h2>Não foi possível carregar os dados</h2>
			<p>{{ error }}</p>
			<button type="button" class="btn-primary" [disabled]="loading" (click)="loadGtm()">Tentar de novo</button>
		</div>

		<ng-container *ngIf="report">
			<section class="section">
				<h2 class="section-title">Resumo</h2>
				<div class="numbers">
					<div class="bloco number">
						<strong>{{ report.summary.activeTags }}</strong>
						<span>{{ report.summary.activeTags === 1 ? 'tag ativa' : 'tags ativas' }}</span>
						<small *ngIf="report.summary.pausedTags">
							{{ report.summary.pausedTags }} {{ report.summary.pausedTags === 1 ? 'pausada' : 'pausadas' }}
						</small>
					</div>
					<div class="bloco number">
						<strong>{{ tools.length }}</strong>
						<span>{{ tools.length === 1 ? 'ferramenta recebendo dados' : 'ferramentas recebendo dados' }}</span>
					</div>
					<div class="bloco number">
						<strong>{{ forms.length }}</strong>
						<span>{{ forms.length === 1 ? 'formulário medido' : 'formulários medidos' }}</span>
					</div>
					<div class="bloco number">
						<strong>{{ clicks.length }}</strong>
						<span>{{ clicks.length === 1 ? 'tipo de clique medido' : 'tipos de clique medidos' }}</span>
					</div>
				</div>
			</section>

			<section class="section">
				<h2 class="section-title">Tags por ferramenta</h2>
				<div class="bloco chart">
					<ul class="bars">
						<li
							*ngFor="let platform of report.platforms"
							[title]="platform.name + ': ' + platform.count + (platform.count === 1 ? ' tag' : ' tags')"
						>
							<span class="bar-label">{{ platform.name }}</span>
							<span class="bar-track">
								<span class="bar" [style.width.%]="(platform.count / maxPlatformCount) * 88"></span>
								<span class="bar-value">{{ platform.count }}</span>
							</span>
						</li>
					</ul>
				</div>
			</section>

			<section class="section" *ngIf="forms.length">
				<h2 class="section-title">Formulários</h2>
				<p class="section-text">Envios de formulário que chegam às ferramentas de marketing como conversão.</p>
				<div class="bloco bloco-table">
					<table>
						<thead>
							<tr>
								<th>Formulário</th>
								<th>Onde fica</th>
								<th>Envia para</th>
							</tr>
						</thead>
						<tbody>
							<tr *ngFor="let form of forms">
								<td class="cell-strong">{{ form.name }}</td>
								<td data-label="Onde fica">{{ form.where }}</td>
								<td data-label="Envia para">
									<span class="tool" *ngFor="let tool of form.tools">{{ tool }}</span>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</section>

			<section class="section" *ngIf="clicks.length">
				<h2 class="section-title">Cliques em botões e links</h2>
				<div class="bloco bloco-table">
					<table>
						<thead>
							<tr>
								<th>Item</th>
								<th>Onde fica</th>
								<th>Envia para</th>
							</tr>
						</thead>
						<tbody>
							<tr *ngFor="let click of clicks">
								<td class="cell-strong">{{ click.name }}</td>
								<td data-label="Onde fica">{{ click.where }}</td>
								<td data-label="Envia para">
									<span class="tool" *ngFor="let tool of click.tools">{{ tool }}</span>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</section>

			<section class="section" *ngIf="visits.length">
				<h2 class="section-title">Visitas às páginas</h2>
				<div class="visits">
					<div class="bloco visit" *ngFor="let visit of visits">
						<h3>{{ visit.page }}</h3>
						<div>
							<span class="tool" *ngFor="let tool of visit.tools">{{ tool }}</span>
						</div>
					</div>
				</div>
			</section>

			<section class="section">
				<details class="all-tags">
					<summary>Ver todas as tags ({{ report.summary.tags }})</summary>

					<div class="filters">
						<button
							type="button"
							[class.is-active]="platformFilter === 'Todas'"
							(click)="setPlatform('Todas')"
						>
							Todas
						</button>
						<button
							*ngFor="let platform of report.platforms"
							type="button"
							[class.is-active]="platformFilter === platform.name"
							(click)="setPlatform(platform.name)"
						>
							{{ platform.name }}
						</button>
						<input
							type="search"
							placeholder="Buscar tag"
							aria-label="Buscar tag"
							[(ngModel)]="search"
							(ngModelChange)="filterTags()"
						/>
					</div>

					<div class="bloco bloco-table">
						<table>
							<thead>
								<tr>
									<th>Tag</th>
									<th>Ferramenta</th>
									<th>Situação</th>
									<th>Quando é acionada</th>
								</tr>
							</thead>
							<tbody>
								<tr *ngFor="let row of filteredTags">
									<td class="cell-strong">{{ row.name }}</td>
									<td data-label="Ferramenta">{{ row.tag.platform }}</td>
									<td data-label="Situação">
										<span class="status" [ngClass]="row.tag.paused ? 'status-warning' : 'status-ok'">
											{{ row.tag.paused ? 'Pausada' : 'Ativa' }}
										</span>
									</td>
									<td data-label="Quando é acionada">
										<div *ngFor="let when of row.when">{{ when }}</div>
									</td>
								</tr>
								<tr *ngIf="!filteredTags.length">
									<td colspan="4" class="empty">Nenhuma tag encontrada.</td>
								</tr>
							</tbody>
						</table>
					</div>
				</details>
			</section>

			<p class="painel-footer">
				Versão {{ report.liveVersion.id }} publicada no Google Tag Manager<ng-container
					*ngIf="report.liveVersion.name"
				>
					({{ report.liveVersion.name }})</ng-container
				>. Lista de formulários e botões revisada em {{ reviewedAt }}.
			</p>
		</ng-container>
	</div>
</div>
